<template>
    <crud-show title="Detalle de Vendedor" :open="open" @close="$emit('close')">
        <v-card-text>
            <vendedor-show-data :item="item" />
        </v-card-text>
    </crud-show>
</template>

<script>
import VendedorShowData from "./VendedorShowData.vue";
import { CrudShow } from "@dracul/common-frontend";

export default {
    name: "VendedorShow",
    components: { CrudShow, VendedorShowData },
    props: {
        open: { type: Boolean, default: true },
        item: { type: Object, required: true },
    },
};
</script>
